  import AlertModal from "../component/AlertModal.svelte";
  export function openAlertModal(props = {}) {
    const modal = new AlertModal({
      target: document.body,
      props: {
        ...props,
        open: true,
      },
    });
    modal.$on("submit", (event) => {
      if (props.submit) props.submit(event);
      modal.$destroy();
    });

    modal.$on("close", () => {
      if (props.onClose) props.onClose();
      modal.$destroy();
    });
    return modal;
  }
